"use strict";

exports.__esModule = true;
exports.shouldOpenPreferencesModal = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _getQueryParams = require("../getQueryParams");
var _filterStaffByLocation = require("../../domain/staff/filterStaffByLocation");
var _filterLocationsByStaff = require("../../domain/location/filterLocationsByStaff");
var _getDefaultLocation = require("../../domain/location/getDefaultLocation");
const shouldOpenPreferencesModal = ({
  service,
  bookingsSettings,
  isDummyService,
  widgetContext,
  queryParams
}) => {
  if (isDummyService || !(0, _bookingsCalendarCatalogViewerMapper.isAppointmentService)(service) || widgetContext != null && widgetContext.isEditorMode || widgetContext != null && widgetContext.isRescheduleFlow || (0, _bookingsCalendarCatalogViewerMapper.isCalendarWidget)(widgetContext == null ? void 0 : widgetContext.widgetName)) {
    return false;
  }
  const isStaffSelectionAllowed = !(0, _getQueryParams.getResourceFromUrl)(queryParams) && ((0, _bookingsCalendarCatalogViewerMapper.isCustomerMayChooseStaff)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isCustomerMustChooseStaff)(bookingsSettings));

  // Whether a *choice* actually survives the staff-by-location filter. Deciding this here,
  // before the modal opens, is the only way to avoid opening one with nothing in it: a
  // modal that opens and immediately confirms itself is worse than never opening.
  //
  // Both use the same predicates as calculateSteps, so the two agree on what a step is
  // for. A location that leaves *nobody* is deliberately still a reason to open — that is
  // the dead end the staff step exists to explain — and isStaffChoiceRedundantAtLocation
  // is false for it, since zero options is not one option.
  const hasLocationChoice = !(0, _filterLocationsByStaff.isLocationChoiceRedundantForStaff)({
    locations: service.locations,
    staffMembers: service.staffMembers
  });
  const hasStaffChoice = !(0, _filterStaffByLocation.isStaffChoiceRedundantAtLocation)({
    staffMembers: service.staffMembers,
    // The location the modal would land on, from the same function the modal itself uses.
    selectedLocation: (0, _getDefaultLocation.getDefaultLocation)({
      service,
      bookingsSettings,
      openedBy: widgetContext == null ? void 0 : widgetContext.widgetName,
      queryParams
    })
  });
  const mustSelectStaffBeforeSlot = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiStaff)(service) && (0, _bookingsCalendarCatalogViewerMapper.isStaffSelectionBeforeSlot)(bookingsSettings) && isStaffSelectionAllowed && hasStaffChoice;
  const mustSelectLocationBeforeSlot = (0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiBusinessLocations)(service) && (0, _bookingsCalendarCatalogViewerMapper.isLocationSelectionBeforeSlot)(bookingsSettings) && !(0, _getQueryParams.getLocationFromUrl)(queryParams) && hasLocationChoice;
  return (0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isServiceWithDynamicDuration)(service) || (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service) || mustSelectStaffBeforeSlot || mustSelectLocationBeforeSlot;
};
exports.shouldOpenPreferencesModal = shouldOpenPreferencesModal;
//# sourceMappingURL=shouldOpenPreferencesModal.js.map